module.exports = __webpack_public_path__ + "static/media/IMG-11.7f05c1d1.jpg";